<template>
  <div class="faq-list">
    <!-- Header with search input -->
    <div class="bg-newColors-green-primaryA">
      <div class="container-small">
        <div class="flex flex-col items-center justify-center">
          <h1 class="mt-4 mb-5 text-3xl text-white md:text-7xl md:mt-16 md:mb-10">{{ translations.heading }}</h1>
          <div class="relative flex items-center w-full mb-3 max-w-928 md:mb-11">
            <input
              v-model="inputText"
              @focus="scrollFaqListIntoView"
              ref="faq-filter"
              type="text"
              name="search"
              placeholder="Skriv din fråga"
              @keyup="keyUpEvents($event)"
              class="w-full px-3 py-2 md:py-2.5 pr-24 text-lg bg-white rounded-lg b placeholder:italic font-futuraEfBook" />
            <button v-if="hasInputText" @click="removeTypedText" class="absolute flex items-center h-full px-3 right-[3.125rem]" type="button">
              <svg xmlns="http://www.w3.org/2000/svg" width="1rem" height="1rem" viewBox="0 0 16 16" fill="none">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M7.99995 6.54551L14.5455 0L16 1.45454L1.45457 16L2.52421e-05 14.5454L6.5454 8.00005L0 1.45465L1.45454 0.00010735L7.99995 6.54551ZM14.5454 16.0001L9.162 10.6167L10.6165 9.16211L16 14.5455L14.5454 16.0001Z"
                  fill="#363433" />
              </svg>
            </button>
            <span class="absolute flex items-center h-8 pl-3.5 right-4 border-l-1 border-newColors-gray-baseB">
              <svg xmlns="http://www.w3.org/2000/svg" width="1.1875rem" height="1.25rem" fill="none" viewBox="0 0 19 20">
                <g clip-path="url(#a)">
                  <mask id="b" width="19" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type: luminance"><path fill="#fff" d="M0 0h18.963v20H0V0Z" /></mask>
                  <g mask="url(#b)">
                    <path
                      fill="#0B8454"
                      fill-rule="evenodd"
                      d="M12.545 11.905A5.986 5.986 0 0 1 8 14c-3.309 0-6-2.692-6-6 0-3.309 2.691-6 6-6a6.006 6.006 0 0 1 5.999 6c0 .915-.212 1.779-.579 2.555l1.807.853A7.912 7.912 0 0 0 15.999 8c0-4.411-3.589-8-7.999-8-4.412 0-8 3.589-8 8s3.588 8 8 8c1.44 0 2.852-.393 4.086-1.136L17.222 20l1.741-1.741-6.418-6.354Z"
                      clip-rule="evenodd" />
                  </g>
                </g>
                <defs>
                  <clipPath id="a"><path fill="#fff" d="M0 0h19v20H0z" /></clipPath>
                </defs>
              </svg>
            </span>
          </div>
        </div>
      </div>
    </div>
    <!-- FAQ list -->
    <section class="bg-newColors-gray-baseC">
      <div class="container-small">
        <div class="py-3 mx-auto md:py-6 max-w-928">
          <!-- Hightlighted category (placed on top) -->
          <ul v-if="itemFromUrl.length > 0" class="mb-5 item-from-url faq-list">
            <li v-for="(category, i) in itemFromUrl" :key="i">
              <ellevio-web-accordion :lastItem="i === itemFromUrl.length - 1" :name="category.category" :tagText="`${category.questions.length} st`" :hiddenFromStart="false">
                <ul class="questions">
                  <li v-for="(question, j) in category.questions" :key="j" class="mb-3 rounded question bg-newColors-gray-background">
                    <div class="flex items-start justify-between">
                      <div class="flex flex-col w-full">
                        <div @click="toggleAnswer($event)" class="flex cursor-pointer">
                          <h4 class="faq-subheading">{{ question.question }}</h4>
                          <button type="button" class="faq-toggle-button-lvl2">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" fill="none">
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M9.74697 9.75166L9.74697 1.25298H12.2529V20.7449L9.74697 20.7449L9.74697 12.2568L1.25387 12.2538L1.25387 9.75166L9.74697 9.75166ZM20.746 12.2541H14.255L14.255 9.7481H20.746L20.746 12.2541Z"
                                fill="#2C2827" />
                            </svg>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" fill="none">
                              <path d="M20.7449 12.253H1.25299L1.25299 9.74703H20.7449L20.7449 12.253Z" fill="#E07300" />
                            </svg>
                          </button>
                        </div>
                        <div class="faq-answer" :class="question.isExpanded ? 'is-extended' : 'hidden'">
                          <div class="wysiwyg wysiwyg-full">
                            <p v-html="question.answer"></p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </ellevio-web-accordion>
            </li>
          </ul>

          <!-- Regular list -->
          <h2 class="inline-block w-full mb-3 text-xl normal-case md:mb-5 md:text-2xl">
            {{ this.inputTextStatic.length > 0 ? searchHeadingComputed : translations.listHeading }}
            <svg v-show="showSpinner" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="inline-block ml-5">
              <circle class="spinner_b2T7" cx="4" cy="12" r="3" />
              <circle class="spinner_b2T7 spinner_YRVV" cx="12" cy="12" r="3" />
              <circle class="spinner_b2T7 spinner_c9oY" cx="20" cy="12" r="3" />
            </svg>
          </h2>
          <ul v-if="matches.length > 0" class="faq-list">
            <li v-for="(category, i) in matches" :key="i">
              <ellevio-web-accordion :lastItem="i === matches.length - 1" :name="category.category" parentText="" :tagText="`${category.questions.length} st`" :hiddenFromStart="!category.isExpanded">
                <ul class="questions">
                  <li v-for="(question, j) in category.questions" :key="j" class="mb-3 rounded question bg-newColors-gray-background">
                    <div class="flex items-start justify-between">
                      <div class="flex flex-col w-full">
                        <div @click="toggleAnswer($event)" class="flex items-center justify-between w-full cursor-pointer">
                          <h4 class="faq-subheading">{{ question.question }}</h4>
                          <button type="button" class="faq-toggle-button-lvl2">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" fill="none">
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M9.74697 9.75166L9.74697 1.25298H12.2529V20.7449L9.74697 20.7449L9.74697 12.2568L1.25387 12.2538L1.25387 9.75166L9.74697 9.75166ZM20.746 12.2541H14.255L14.255 9.7481H20.746L20.746 12.2541Z"
                                fill="#2C2827" />
                            </svg>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" fill="none">
                              <path d="M20.7449 12.253H1.25299L1.25299 9.74703H20.7449L20.7449 12.253Z" fill="#E07300" />
                            </svg>
                          </button>
                        </div>
                        <div class="faq-answer" :class="question.isExpanded ? '' : 'hidden'">
                          <div class="wysiwyg wysiwyg-full">
                            <p v-html="question.answer"></p>
                          </div>
                          <p v-if="question.lastChangedDate" class="mt-8 text-lg">{{ `${translations.updated}: ${question.lastChangedDate}` }}</p>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </ellevio-web-accordion>
            </li>
          </ul>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import store from '../../../store/index'
import EllevioWebAccordion from './Accordion.vue'
export default {
  name: 'ellevio-web-faq-list',
  components: {
    EllevioWebAccordion
  },
  props: {
    categories: {
      type: Array,
      default: () => []
    },
    translations: {
      type: Object,
      default: () => {}
    },
    apiUrl: {
      type: String,
      default: ''
    },
    debounceDelay: {
      type: Number,
      default: 200
    }
  },
  data() {
    return {
      faqCategories: [],
      itemFromUrl: [],
      inputText: '',
      inputTextStatic: '',
      dataFromApi: [],
      timeoutId: 0,
      showSpinner: false
    }
  },
  computed: {
    searchHeadingComputed() {
      return this.formatString(this.translations.searchHeading, this.inputTextStatic, this.getNumberOfHits)
    },

    getDataFromApi() {
      return this.dataFromApi
    },
    getNumberOfHits() {
      return this.getDataFromApi.length > 0 ? this.getDataFromApi.reduce((acc, item) => acc + item.questions.length, 0) : this.translations.noHitsNumberText ?? 'inga'
    },
    matches() {
      const sortedFaqCategories = [...this.faqCategories].filter((category) => category.isHighlighted !== true).sort(this.sortAlphabetically)
      return this.getDataFromApi.length > 0 ? this.getDataFromApi : sortedFaqCategories
    },
    hasInputText() {
      return this.inputText.length > 0
    },
    matchMediaQuery() {
      return window.matchMedia(' (min-width: 1024px) ')
    }
  },
  methods: {
    async getData() {
      return await store.dispatch('getTypeAheadCategoriesFaq', { query: this.inputText, apiUrl: this.apiUrl })
    },
    formatString(str, ...values) {
      return str.replace(/{(\d+)}/g, function (match, index) {
        return typeof values[index] !== 'undefined' ? (+index === 0 ? `"${values[index]}"` : values[index]) : match
      })
    },
    toggleQuestions($event) {
      $event.currentTarget.parentElement.querySelector('ul').classList.toggle('hidden')
    },
    toggleAnswer($event) {
      $event.stopPropagation()
      $event.currentTarget.parentElement.querySelector('div+div:has(.wysiwyg)').classList.toggle('hidden')
    },
    makeApiCall() {
      this.showSpinner = true
      this.faqCategories = []

      //debounce api call
      clearTimeout(this.timeoutId)
      this.timeoutId = setTimeout(async () => {
        const dataReturned = await this.getData()
        this.showSpinner = false
        this.inputTextStatic = this.inputText
        this.dataFromApi = dataReturned.data
      }, this.debounceDelay)
    },
    keyUpEvents: async function ($event) {
      this.itemFromUrl = [] //should never be populated from api
      this.inputText = $event.target.value
      this.makeApiCall()
    },
    sortAlphabetically(a, b) {
      if (a.name < b.name) {
        return -1
      }
      if (a.name > b.name) {
        return 1
      }
      return 0
    },
    scrollFaqListIntoView() {
      if (this.isMobile) {
        document.querySelector('.faq-list').scrollIntoView({ behavior: 'smooth' })
      }
    },
    scrollIntoView(selector) {
      selector.scrollIntoView({ behavior: 'smooth' })
    },
    removeTypedText() {
      this.inputText = ''
      this.makeApiCall()
      this.$refs['faq-filter'].focus()
    },

    resize: function () {
      this.isMobile = this.matchMediaQuery ? !this.matchMediaQuery.matches : true
    }
  },
  async mounted() {
    this.isMobile = this.matchMediaQuery ? !this.matchMediaQuery.matches : true
    this.itemFromUrl = this.categories.filter((item) => item.isHighlighted === true)

    this.faqCategories = [...this.categories]

    this.$nextTick(function () {
      const extendedItemsFromUrl = document.querySelectorAll('.is-extended')
      if (extendedItemsFromUrl.length > 0) {
        this.scrollIntoView(extendedItemsFromUrl[0].previousSibling)
      }
    })
  },
  unmounted() {
    window.removeEventListener('resize', this._boundedResize)
  }
}
</script>
<style scoped>
.faq-subheading {
  @apply w-full px-5 py-3 text-base leading-tight normal-case md:text-xl font-futuraEfDemiBold;
}
.faq-subheading:first-letter {
  text-transform: uppercase;
}

.faq-toggle-button-lvl2 {
  @apply p-3 rounded-sm;
}

.faq-list svg {
  @apply w-5 h-5;
}

.faq-answer {
  @apply px-5 pb-3;
}

button > svg + svg {
  display: none;
}
li.question:has(p + p.hidden) p:first-child {
  margin-bottom: 0;
}
li.category:not(:has(ul.questions.hidden)) button > svg:first-child {
  display: none;
}
li.category:not(:has(ul.questions.hidden)) button > svg + svg {
  display: block;
}
li.category:has(ul.questions.hidden) button > svg:first-child path,
li.question:has(.faq-answer.hidden) button > svg:first-child path {
  fill: #2c2827;
  transition: fill 0.3s ease-in-out;
}
li.category:has(ul.questions.hidden):hover button > svg:first-child path,
li.question:has(.faq-answer.hidden):hover button > svg:first-child path {
  fill: #ff8300;
}
li.question {
  border: 1px solid transparent;
}
li.question:hover {
  border: 1px solid #cdcbca;
}
li.question:has(.faq-answer.hidden) button > svg:first-child {
  display: block;
}
li.question:has(.faq-answer.hidden) button > svg + svg {
  display: none;
}
li.question:not(:has(.faq-answer.hidden)) button > svg:first-child {
  display: none;
}
li.question:not(:has(.faq-answer.hidden)) button > svg + svg {
  display: block !important;
}
button:focus:focus-visible {
  outline: 2px dotted #000;
  outline-offset: 3px;
}
.spinner_b2T7 {
  animation: spinner_xe7Q 0.8s linear infinite;
}
.spinner_YRVV {
  animation-delay: -0.65s;
}
.spinner_c9oY {
  animation-delay: -0.5s;
}
@keyframes spinner_xe7Q {
  93.75%,
  100% {
    r: 3px;
  }
  46.875% {
    r: 0.2px;
  }
}
</style>
